import "./styles.scoped.css";
export default {
    "icon-shake": "awsui_icon-shake_1cbgc_1dmb0_97",
    "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_1cbgc_1dmb0_1",
    "container-fade-in": "awsui_container-fade-in_1cbgc_1dmb0_125",
    "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1cbgc_1dmb0_1",
    "root": "awsui_root_1cbgc_1dmb0_147",
    "status-error": "awsui_status-error_1cbgc_1dmb0_154",
    "status-warning": "awsui_status-warning_1cbgc_1dmb0_157",
    "status-success": "awsui_status-success_1cbgc_1dmb0_160",
    "status-info": "awsui_status-info_1cbgc_1dmb0_163",
    "status-stopped": "awsui_status-stopped_1cbgc_1dmb0_166",
    "status-pending": "awsui_status-pending_1cbgc_1dmb0_169",
    "status-in-progress": "awsui_status-in-progress_1cbgc_1dmb0_172",
    "status-loading": "awsui_status-loading_1cbgc_1dmb0_175",
    "color-override-red": "awsui_color-override-red_1cbgc_1dmb0_178",
    "color-override-grey": "awsui_color-override-grey_1cbgc_1dmb0_181",
    "color-override-blue": "awsui_color-override-blue_1cbgc_1dmb0_184",
    "color-override-green": "awsui_color-override-green_1cbgc_1dmb0_187",
    "icon": "awsui_icon_1cbgc_1dmb0_97",
    "container": "awsui_container_1cbgc_1dmb0_125",
    "overflow-ellipsis": "awsui_overflow-ellipsis_1cbgc_1dmb0_201"
};
